<template>
    <div data-select-root class="select" :key="id" :id="id"> 
        <div @click="hideOrShowSelect">
            <div v-if="multiple" class="tag-container multiple justify-content-between align-items-center"  >
                <div class="d-flex" style="gap:5px; flex-wrap: wrap;" v-if="selected && selected.length">
                    <div v-for="(tag, i) in selected" class="tag">
                        <span>{{ tag.label }}</span>
                        <button @click.stop.prevent="toggleTag(tag)">
                            <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div style="color:gray;" v-else>
                    {{ placeholder }}
                </div>
                <div style="display: flex; align-items: center;">
                    <svg :style="selectOpen ? 'rotate: 180deg;' : ''" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                    </svg>
                </div>
            </div>
            <div v-else class="tag-container">
                <div>
                    {{ selected ? selected.label : 'Select' }}
                </div>
                <div style="display: flex; align-items: center;">
                    <svg :style="selectOpen ? 'rotate: 180deg;' : ''" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                    </svg>              
                </div>
            </div>
        </div>
        <ul v-if="selectOpen" class="dropdown">
            <li data-select-item v-for="(opt, idx) in alteredOptions" @click="toggleTag(opt)" class="dropdown-item" :class="opt.selected ? 'selected': ''">
                
                <div class="dropdown-item-div">
                    <label v-if="multiple" style="pointer-events: none;" class="checkbox-container m-0">
                        <input type="checkbox" v-model="opt.selected">
                        <span class="checkmark">
                            <svg class="checkmark-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <path class="checkmark-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                            </svg>
                        </span>
                    </label>
                    <span>{{ opt.label }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { v4 } from "uuid";

export default {
    props:{
        value: {
            type: String | Array,
            required: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        options:{
            type: Array,
            required: true
        },
        placeholder:{
            type: String,
            default: "select"
        }
    },
    data(){
        return {
            alteredOptions: [],
            selectOpen: false,
            selected: [],
            selectedIndexes: [],
            id: null,
            root: null
        }
    },   
    watch:{
        options(nv){
            if(!this.multiple) this.populateAlteredOptions(nv);
        },
        value(nv){
            if(!nv) {
                this.selected = []
                this.alteredOptions.forEach(el =>{
                    el.selected = false
                })
            }
        }
    },
    methods:{
        toggleTag(opt){
            opt.selected = !opt.selected;
            if(this.multiple){
                this.selected =  this.alteredOptions.filter(el => el.selected)
                this.$emit('input', this.selected.map(el => el.value));
                this.$emit('change', this.selected.map(el => el.value));
            }else{
                opt.selected = true;
                this.selected = opt.selected ? opt :  null;
                this.alteredOptions.forEach(el => {
                    if(el.value != opt.value) el.selected = false;
                })
                this.$emit('input', this.selected.value);
                this.$emit('change', this.selected.value);
                this.selectOpen = false;
            }

        },
        hideOrShowSelect(){
            this.selectOpen = !this.selectOpen
        },
        populateAlteredOptions(data = []){
            this.alteredOptions = [];
            data.forEach(el =>{
                el.selected = false;
                this.alteredOptions.push(el)
            })
        },
        populateValue(value){
            if(this.multiple && value){
                this.alteredOptions.forEach(el =>{
                    if(value.includes(el.value)){
                        el.selected = true
                        this.selected.push(el)
                    }
                })
            }else if(value){
                this.selected = value
            }
        }
    },
    mounted(){
        this.id = `sel${v4()}`
        this.populateAlteredOptions(this.options)
        document.body.addEventListener("click", e=>{
            this.root = document.querySelector( '#'+ this.id + '[data-select-root]');
            if(this.root && !this.root.contains(e.target)) this.selectOpen = false;
            
        })

        this.populateValue(this.value)

        
    }
}
</script>

<style scoped lang="scss">
button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
}

ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.select{
    position: relative;
}


.tag-container{
    background: #fff;
    height: 100%;
    padding: 9px 15px;
    width: 100%;
    border-radius: 5px;
    font-size: 0.9rem;
    border: 0.5px solid rgb(223, 223, 223);
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    align-items: center;

    &:focus,
    &:active{
        outline: red;
    }

    svg{
        height: 16px;
        width: 16px;
        stroke: black;
    }
}

.tag-container.multiple{
    gap:5px;
    justify-content: start;
}

.tag{
    width: max-content;
    border-radius: 10px;
    background: greenyellow;
    padding: 2px 7px;
    font-size: 0.75rem;
    display: flex;
    gap: 5px;
    align-items: center;
}

.tag svg{
    height: 16px; 
    width: 16px;

    &:hover{
        stroke: green;
    }
}


.dropdown{
    position: absolute;
    background: #ffffff;
    width: 100%;
    z-index: 9999;
    border: 0.5px solid rgb(208, 208, 208);
    max-height: 500px;
    overflow-y: auto;

    .dropdown-item{
        cursor: pointer;
        padding: 5px 10px;
        width: 100%;
        &:hover{
            background: rgb(231, 242, 255);
        }
        &:focus,
        &:active {
            background: none;
            color: black
        }
    }
    .dropdown-item.selected{
        background: #bee1ff;
        &:hover{
            background: #bee1ff;
        }
    }

    .dropdown-item-div{
        display: flex;
        gap:15px;
        align-items: center;
    }
}

/* Hide the default checkbox */
.checkbox-container input {
    display: none;
}
.checkbox-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
/* Create a custom checkbox */
.checkbox-container .checkmark {
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #ffffff;
    position: relative;
    cursor: pointer;
    border: 0.5px solid rgb(211, 211, 211);
}
/* Hide the SVG checkmark by default */
.checkbox-container .checkmark-svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    stroke-width: 5;
    stroke: #ffffff;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 71;
    stroke-dashoffset: 71;
    transition: all 0.3s ease-out;
    opacity: 0;
}

/* Show the SVG checkmark when the checkbox is checked */
.checkbox-container input:checked ~ .checkmark .checkmark-svg {
    stroke-dashoffset: 0;
    opacity: 1;
}
.checkbox-container input:checked ~ .checkmark {
    background: #409EFF;
    border-color: #409EFF;
}



</style>